import React from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import styled from "styled-components";
import { Stack } from "@mui/material";
import ChartColors from "./chart-colors";
import ChartColorsExpanded from "./chart-colors-expanded";

const TooltipContainer = styled.div`
    background-color: ${({ theme }) => theme.palette.background.tooltip};
    padding: 0.5rem;
    min-width: 10rem;
    align-items: center;
    flex-direction: column;
    border-radius: 6px;
`;

const TooltipContent = styled.p`
    font-size: 12px;
    margin: 0;
    color: ${({ color }) => color};
`;

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        return (
            <TooltipContainer
                className="failures-per-stage-tooltip"
                role="status"
                aria-live="assertive"
            >
                {payload.map((entry) => (
                    <Stack direction="row" spacing={0.5} key={entry.name}>
                        <TooltipContent color={entry.color}>{`${entry.name}`} : </TooltipContent>
                        <TooltipContent> {entry.value}</TooltipContent>
                    </Stack>
                ))}
            </TooltipContainer>
        );
    }
    return null;
};

const transformArray = (inputArray, types, issuesOrPoints) => {
    const count = Object.keys(types).reduce(
        (acc, type) => ({
            ...acc,
            [type]: 0,
        }),
        {}
    );

    inputArray.forEach((item) => {
        if (count[item.type] !== undefined) {
            count[item.type] += item.value[issuesOrPoints];
        } else {
            count.Other += item.value[issuesOrPoints];
        }
    });

    return [count];
};

const TicketsBreakdownChart = ({ issues, types, issuesOrPoints }) => {
    if (!issues) return null;
    const data = transformArray(issues, types, issuesOrPoints);

    const HandleColors = (index) => {
        if (data.length <= 20) {
            return ChartColors[index % ChartColors.length];
        }
        if (data.length > 20) {
            return ChartColorsExpanded[index % ChartColorsExpanded.length];
        }
        return null;
    };

    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                accessibilityLayer
                layout="vertical"
                stackOffset="expand"
                width={50}
                height={20}
                data={data}
            >
                <XAxis type="number" hide />
                <YAxis type="category" dataKey="expectedTotal" hide />
                <Tooltip
                    wrapperStyle={{ zIndex: 1000 }}
                    cursor={{ opacity: "0.2" }}
                    content={CustomTooltip}
                />
                {Object.keys(types).map((type, i) => (
                    <Bar
                        dataKey={type}
                        name={type}
                        key={type}
                        fill={HandleColors(i)}
                        stackId="a"
                        maxBarSize={25}
                    />
                ))}
            </BarChart>
        </ResponsiveContainer>
    );
};

export default TicketsBreakdownChart;
